import React from 'react';

const DateInput = ({
  label,
  name,
  value,
  onChange,
  required = false,
  placeholder = 'Select date',
  max = '2100-12-31',
  min = '1900-01-01',
}) => {
  // Convert date string to YYYY-MM-DD format for input value
  const formatDateForInput = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '';
    return date.toISOString().split('T')[0];
  };

  // Handle date change and format it
  const handleDateChange = (e) => {
    const date = e.target.value;
    onChange({
      target: {
        name,
        value: date,
      },
    });
  };

  return (
    <div className="form-group mb-4">
      {label && (
        <label htmlFor={name} className="form-label">
          {label} <span className="required-star">{required?'*':''}</span>
        </label>
      )}
      <input
        type="date"
        id={name}
        name={name}
        className="form-control"
        value={formatDateForInput(value)}
        onChange={handleDateChange}
        required={required}
        placeholder={placeholder}
        max={max}
        min={min}
      />
    </div>
  );
};

export default DateInput;
